import React from "react";
import styles from "./AboutPage.module.css";

function AboutPage() {
    return (
        <div className={styles.aboutContainer}>
            <h1>About</h1>
            <p>Expense Tracker made by Oliver Wigren. The web app utilizes full CRUD functionality. The user can create create and delete transactions and visualize them next to a budget for each category.</p>
        </div>
    )
}

export default AboutPage;